var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputIcoCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5H10V10H12.5V12.5ZM8.75 6.25H6.25V8.75H8.75V6.25ZM12.5 6.25H10V8.75H12.5V6.25ZM5 10H2.5V12.5H5V10ZM8.75 10H6.25V12.5H8.75V10ZM5 6.25H2.5V8.75H5V6.25ZM15 1.25V15H0V1.25H1.875V1.875C1.875 2.56437 2.43563 3.125 3.125 3.125C3.81437 3.125 4.375 2.56437 4.375 1.875V1.25H10.625V1.875C10.625 2.56437 11.1856 3.125 11.875 3.125C12.5644 3.125 13.125 2.56437 13.125 1.875V1.25H15ZM13.75 5H1.25V13.75H13.75V5ZM12.5 0.625C12.5 0.28 12.2206 0 11.875 0C11.5294 0 11.25 0.28 11.25 0.625V1.875C11.25 2.22 11.5294 2.5 11.875 2.5C12.2206 2.5 12.5 2.22 12.5 1.875V0.625ZM3.75 1.875C3.75 2.22 3.47062 2.5 3.125 2.5C2.77938 2.5 2.5 2.22 2.5 1.875V0.625C2.5 0.28 2.77938 0 3.125 0C3.47062 0 3.75 0.28 3.75 0.625V1.875Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputIcoCalendar);
export default __webpack_public_path__ + "static/media/input-ico-calendar.4863634f2fff52177fd3cc92d9433b19.svg";
export { ForwardRef as ReactComponent };